import { useState } from 'react';
import type { SelectionButtonsProps } from './types';
import BuildColumns from './BuildColumns';
import styles from './index.module.less';
import { Type } from '../../../core/enums';
import Element from '../../../core/Element';

// component is stateless: onChange and selectedIndex provide the effects
// of state changes above
export const SelectionButtons = ({
  data: {
    colorChoices = [],
    onChange = () => {},
    selectedIndex = -1,
    legend = {
      id: '',
      name: '',
      showAsTitle: false,
      theme: {},
      direction: '',
    },
    ariaLabelledby,
    expanded = false,
    forceColumn = false,
  },
  tools,
  qeID,
  $type = Type.Primary,
}: SelectionButtonsProps) => (
  <Element className={expanded ? '' : styles.rootClassCompact}>
    <BuildColumns
      colorChoices={colorChoices}
      legend={legend}
      ariaLabelledby={ariaLabelledby}
      selectedIndex={selectedIndex}
      isExpanded={expanded}
      onChange={onChange}
      forceColumn={forceColumn}
      tools={tools}
      qeID={qeID}
      type={$type}
    />
  </Element>
);

// don't use this, brah
export const StatefulSelectionButtons = ({
  data,
}: {
  data: React.ComponentProps<typeof SelectionButtons>['data'];
}) => {
  const [selectedIndex, setSelected] = useState(0);

  const onChange = (index: number) => {
    setSelected(index);
  };

  const combinedData = {
    ...data,
    selectedIndex,
    onChange,
  };

  return <SelectionButtons data={combinedData} />;
};
